export default __webpack_public_path__ + "static/media/morning.b094c1a0.svg";